import type { CityConfig } from "../city-template/types";

export const royalOakConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Oakland County Clerk", href: "https://www.oakgov.com/clerkrod/", description: "Oakland County Clerk — marriage license issuance" },
    { label: "Divorce Records — Oakland County Clerk", href: "https://www.oakgov.com/clerkrod/", description: "Oakland County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Royal Oak",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "royal-oak",
  route: "/cities/royal-oak",
  title: "Emergency Passport Royal Oak, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Royal Oak, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Royal Oak, Berkley, Ferndale, Madison Heights, and Clawson. Detroit Passport Agency access. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Royal Oak, MI",
  heroSubtitle: "Royal Oak residents trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Home to Royal Oak's thriving downtown, Detroit Zoo, and the Woodward Avenue corridor, our registered couriers serve all of southern Oakland County. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Vibrant%20downtown%20Main%20Street%20of%20Royal%20Oak%20Michigan%20with%20charming%20shops%2C%20restaurants%2C%20and%20historic%20buildings%20along%20a%20tree-lined%20avenue%2C%20warm%20evening%20atmosphere%20with%20string%20lights%2C%20small-town%20charm%20mixed%20with%20urban%20energy%2C%20people%20walking%20casually%2C%20colorful%20storefronts%2C%20American%20suburban%20downtown%2C%20no%20text%2C%20high%20quality%20photography%20with%20warm%20golden%20tones&width=1800&height=700&seq=royal-oak-hero-001&orientation=landscape",
  heroImageAlt: "Royal Oak Michigan downtown Main Street with shops and restaurants",
  geoPosition: "42.4895;-83.1446",
  geoPlacename: "Royal Oak, Michigan",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 15 miles south in downtown Detroit — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Royal Oak", zips: "48067, 48068, 48069, 48073" },
    { name: "Berkley", zips: "48072" },
    { name: "Ferndale", zips: "48220" },
    { name: "Madison Heights", zips: "48071" },
    { name: "Clawson", zips: "48017" },
    { name: "Huntington Woods", zips: "48070" },
    { name: "Pleasant Ridge", zips: "48069" },
    { name: "Southfield", zips: "48033, 48034, 48075, 48076" },
    { name: "Troy", zips: "48083, 48084, 48085, 48098, 48099" },
    { name: "Birmingham", zips: "48009, 48012" },
    { name: "Bloomfield Hills", zips: "48301, 48302, 48304" },
    { name: "Pontiac", zips: "48340, 48341, 48342, 48343" },
    { name: "Sterling Heights", zips: "48310, 48311, 48312, 48313, 48314" },
    { name: "Warren", zips: "48088, 48089, 48091, 48092, 48093" },
    { name: "Detroit", zips: "48201, 48202, 48203, 48204, 48205, 48206, 48207, 48208, 48209, 48210, 48211, 48212, 48213, 48214, 48215, 48216, 48217, 48219, 48221, 48223, 48224, 48226, 48227, 48228, 48234, 48235, 48238, 48239, 48240" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "Southern Oakland County", desc: "Serving Royal Oak, Berkley, Ferndale, and Madison Heights" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — drop off at any UPS or FedEx" },
  ],
  internalLinks: [
    { name: "Expedited passport in Detroit, MI", route: "/cities/detroit" },
    { name: "Emergency passport services in Troy, MI", route: "/cities/troy-mi" },
    { name: "Urgent passport services in Southfield, MI", route: "/cities/southfield" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Royal Oak, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Royal Oak residents can ship from any UPS or FedEx in southern Oakland County.",
  fpcOfficeDistance: "Serving Royal Oak, Berkley, Ferndale, Madison Heights, Clawson, Huntington Woods, Pleasant Ridge, and all of southern Oakland County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Royal Oak and southern Oakland County. From the vibrant downtown dining district to the Detroit Zoo neighborhood, from the Woodward Avenue corridor to the border with Wayne County — we serve all of Royal Oak and surrounding communities.",
  nearbyCitiesIntro: "We serve Royal Oak and all southern Oakland County communities including Berkley, Ferndale, Madison Heights, Clawson, Huntington Woods, Pleasant Ridge, Southfield, Troy, Birmingham, and Bloomfield Hills. We also serve neighboring Wayne County communities including Detroit, Warren, and Sterling Heights.",
  howItWorksIntro: "Most Royal Oak travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Royal Oak's young professionals and growing families often discover passport issues before last-minute trips, concerts, or cruises. Here are the most common passport mistakes we see from southern Oakland County travelers.",
  testimonialsIntro: "Royal Oak travelers — from downtown professionals to young families at the Detroit Zoo — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Royal Oak, MI? Here are the most common ones we hear from southern Oakland County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for downtown professionals and young families", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Royal Oak travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Perfect for concert tours and last-minute trips"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Royal Oak adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Royal Oak address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Royal Oak residents and young professionals — including downtown workers and young families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Royal Oak residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Royal Oak families planning international vacations.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Royal Oak residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Royal Oak MI", description: "Urgent passport processing for Royal Oak Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Royal Oak MI", description: "Fast passport renewal for Royal Oak Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Royal Oak MI", description: "New passport application services for Royal Oak Michigan residents applying for their first passport." },
    { name: "Child Passport Royal Oak MI", description: "Minor passport services for Royal Oak Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Emily S.",
      location: "Royal Oak, MI",
      rating: 5,
      text: "Last-minute concert trip to London in 5 days. My passport was expired and I panicked. Fast Passport Center got my renewal done in 2 days. I literally picked it up the morning before my flight.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Chris D.",
      location: "Ferndale, MI",
      rating: 5,
      text: "Two passports for our kids before our Disney cruise. Fast Passport Center made it so easy — the whole process took 4 days from start to finish. We shipped from the FedEx on Woodward.",
      service: "Family Passport Bundle",
    },
    {
      name: "Lauren B.",
      location: "Royal Oak, MI",
      rating: 5,
      text: "Needed a business passport for a conference in Tokyo. Fast Passport Center was professional, communicative, and delivered ahead of schedule. Would absolutely recommend to anyone in Royal Oak.",
      service: "Passport Renewal",
    },
    {
      name: "Tom H.",
      location: "Berkley, MI",
      rating: 5,
      text: "Lost my passport two days before a trip to Mexico. Fast Passport Center had a replacement in my hands in 36 hours. I honestly didn't think it was possible. Amazing service.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "royal-oak-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 15 miles south in downtown Detroit",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "royal-oak-2",
      name: "Royal Oak Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 W 2nd St",
      city: "Royal Oak",
      state: "MI",
      zip: "48067",
      phone: "(248) 546-1400",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Royal Oak — near the main business district",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Royal Oak residents. Convenient to downtown, the Detroit Zoo area, and southern Oakland County communities.",
      icon: "ri-mail-line",
    },
    {
      id: "royal-oak-3",
      name: "Ferndale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1430 E 9 Mile Rd",
      city: "Ferndale",
      state: "MI",
      zip: "48220",
      phone: "(248) 542-5800",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ferndale — approximately 3 miles south of Royal Oak",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular with Ferndale and southeast Royal Oak residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "royal-oak-4",
      name: "Madison Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "27455 John R Rd",
      city: "Madison Heights",
      state: "MI",
      zip: "48071",
      phone: "(248) 583-1300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Madison Heights — approximately 4 miles north of Royal Oak",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Madison Heights and northern Royal Oak area. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "royal-oak-5",
      name: "Southfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "22250 W 11 Mile Rd",
      city: "Southfield",
      state: "MI",
      zip: "48034",
      phone: "(248) 353-4430",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southfield — approximately 6 miles northwest of Royal Oak",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Southfield and northwest Royal Oak residents. Ample parking and convenient to the Northwestern Highway corridor.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Royal Oak" },
    { feature: "Young Professional Focus", agency: "No tailored advice", fpc: "Yes — flexible for busy schedules" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Royal Oak's busy professionals and young families often discover passport issues before concert trips, cruises, or international vacations. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Not Checking Passport Validity for Europe",
      description: "Many Royal Oak travelers heading to European concerts or festivals don't realize their passport needs to be valid for 6 months past their return date. European countries strictly enforce this rule.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Royal Oak-area acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Planning for Group Travel",
      description: "Royal Oak groups heading to concerts or festivals often apply individually at different times. This leads to staggered passport arrivals. Fast Passport Center processes group applications together for coordinated delivery.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Royal Oak." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Royal Oak, Ferndale, or Southfield." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Royal Oak address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport facility to Royal Oak?", a: "The nearest passport acceptance facility is the Royal Oak Post Office at 200 W 2nd St in downtown Royal Oak. The Detroit Passport Agency at 211 W. Fort St, Suite 1300 is the nearest regional agency for expedited processing. Fast Passport Center's couriers have direct access to the Detroit Passport Agency without you needing an appointment." },
    { q: "How fast can I get an emergency passport in Royal Oak?", a: "Fast Passport Center offers emergency passport processing in Royal Oak, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to take a day off work or drive to downtown Detroit." },
    { q: "Do Royal Oak residents need to go to the Detroit Passport Agency in person?", a: "No. With Fast Passport Center, you ship your documents from Royal Oak and we handle the in-person submission at the Detroit Passport Agency for you. Our registered courier is authorized by the U.S. Department of State to submit applications on your behalf." },
    { q: "Can Royal Oak residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Royal Oak, Ferndale, and Southfield offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "What is the closest airport to Royal Oak for international travel?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is approximately 30 minutes from Royal Oak via I-75 or I-696. DTW is the primary international departure hub for Metro Detroit with direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and dozens of other international destinations." },
    { q: "Does Fast Passport Center serve the suburbs around Royal Oak?", a: "Yes. We serve all of southern Oakland County including Berkley, Ferndale, Madison Heights, Clawson, Huntington Woods, Pleasant Ridge, Southfield, Troy, Birmingham, and Bloomfield Hills. We also serve neighboring Wayne County communities." },
    { q: "How much does an expedited passport cost in Royal Oak, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can I get a passport for a group of Royal Oak friends traveling together?", a: "Yes. Fast Passport Center handles group passport applications — whether it's a bachelor party, concert tour, or family reunion. We process all applications together so everyone receives their passport at the same time. Group rates may apply." },
  ],
  photoLocations: [
    { name: "Walgreens — Royal Oak", address: "300 S Main St, Royal Oak, MI 48067", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Royal Oak", address: "1800 E 12 Mile Rd, Royal Oak, MI 48067", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Royal Oak", address: "301 S Main St, Royal Oak, MI 48067", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Southfield", address: "21000 W 10 Mile Rd, Southfield, MI 48075", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Royal Oak", address: "26890 Woodward Ave, Royal Oak, MI 48067", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Located on the historic Woodward Avenue corridor.", featured: true },
    { name: "Michigan SOS — Ferndale", address: "440 W 9 Mile Rd, Ferndale, MI 48220", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Ferndale and southeast Royal Oak communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "30 minutes from Royal Oak via I-75 or I-696",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Metro Detroit. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "YQG",
      name: "Windsor Airport (Canada)",
      distance: "25 minutes from Royal Oak via I-75 and Ambassador Bridge",
      address: "3200 County Rd 42, Windsor, ON N9A 6J3, Canada",
      note: "Secondary option for travelers crossing to Canada first. Requires passport for air travel to/from Canada.",
      flightUrl: "https://www.yqg.ca/",
      flightLabel: "Windsor Airport Info",
      featured: false,
    },
  ],
};